/* SurveyMarshal.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./SurveyMarshal.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Transition } from 'react-transition-group';
import { layers } from '@atlaskit/theme/constants';
// 8px is the base unit in pixels
var surveyOffset = "var(--ds-space-600, 48px)";
var animationDuration = 300;
var offscreen = {
  // Hard-coded because there is no large enough space token and this component is not responsive.
  translateX: '488px',
  //survey container width + survey offset
  opacity: '0'
};
var getAnimationProps = function getAnimationProps(state) {
  switch (state) {
    case 'entered':
      {
        return {
          translateX: '0',
          opacity: '1'
        };
      }
    case 'entering':
    case 'unmounted':
    case 'exited':
    case 'exiting':
      {
        return offscreen;
      }
  }
};
var transitionBaseStyles = null;
export default function SurveyMarshal(props) {
  var children = props.children,
    shouldShow = props.shouldShow;
  return /*#__PURE__*/React.createElement(Transition, {
    in: shouldShow,
    timeout: animationDuration,
    unmountOnExit: true
  }, function (state) {
    var _getAnimationProps = getAnimationProps(state),
      translateX = _getAnimationProps.translateX,
      opacity = _getAnimationProps.opacity;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        opacity: opacity,
        transition: "all ".concat(animationDuration, "ms ease-in-out"),
        zIndex: layers.flag(),
        transform: "translateX(".concat(translateX, ")")
      },
      className: ax(["_kqsw1n9t _1xi2oahv _94n5oahv _k8m01rjc"])
    }, children());
  });
}